<div>
  <netz-page-heading>Manage facilities list</netz-page-heading>

  <h2 class="govuk-heading-m">Facilities</h2>

  <cca-facility-item-list [facilityItems]="manageFacilities().facilityItems"></cca-facility-item-list>
</div>
